import { render, staticRenderFns } from "./ReviewTagsSelector.vue?vue&type=template&id=61660882&scoped=true&"
import script from "./ReviewTagsSelector.vue?vue&type=script&lang=js&"
export * from "./ReviewTagsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTagsSelector.vue?vue&type=style&index=0&id=61660882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61660882",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
